import { Divider, Grid, useMediaQuery } from '@mui/material';
import React, { useMemo, useState } from 'react'
import styles from "../../../../../../assets/styles/componentStyles/chatbotStyles/chats.module.scss";
import globalStyles from "../../../../../../assets/styles/global.module.scss";
import { fontColorForMethod, getValueOrDefault } from '../../../../../../utils/constants';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import GlobalPopUp from '../../../../../../components/utility/globalPopUp';
import IconsColor from '../../../../../../components/utility/iconsColor';
import CustomAPIActionInformationPopup from './customAPIActionInformationPopup';
import { getTimeDifferences } from '../../../../utils';

interface CustomAPIActionProps {
    actionData: any,
    thread: any,
} 

const CustomAPIAction: React.FC<CustomAPIActionProps> = (props) => {
    
    const { actionData, thread } = props;
    const [flagOpenCustomAPIInfoPopup, setFlagOpenCustomAPIInfoPopup] = useState<boolean>(false);
    const flagSmallScreen = useMediaQuery<boolean>('(min-width: 0px) and (max-width: 1000px)');

    const apiMethod = useMemo(() => {
        return getValueOrDefault(actionData?.custom_api_method);
    }, [actionData, getValueOrDefault]);

    const urlOrFunctionName = useMemo(() => {
        return getValueOrDefault(actionData?.custom_api_url ?? actionData?.data_connector_function_name);
    }, [actionData, getValueOrDefault]); 

    const statusCode = useMemo(() => {
        return getValueOrDefault(actionData?.custom_api_response_code);
    }, [actionData, getValueOrDefault]);

    const executionTime = useMemo(() => {
        if(thread?.step_start_timestamp && thread?.step_end_timestamp){
            return getTimeDifferences(thread?.step_start_timestamp, thread?.step_end_timestamp);
        }
        return "-";
    }, [thread, getTimeDifferences]);

    return (
        <>
            <Grid container className={`${styles.customAPIMsgMainContainer} ${globalStyles.flexColumn}`} gap={1}>
                <Grid item className={globalStyles.fullwidth}>
                    <Grid container className={`${globalStyles.spaceAlignmentCenter} ${globalStyles.alignItemCenter}`}>
                        <Grid item className={styles.customAPICallMsgTitle}>
                            <Grid container className={globalStyles.alignItemCenter} gap={"14px"}>
                                <Grid item>
                                    API Call
                                </Grid>
                               <Grid item className={styles.customAPIMethod} sx={{color: actionData?.custom_api_method ? fontColorForMethod(actionData?.custom_api_method) : "black", boxShadow: `0 0 2px ${actionData?.custom_api_method ? fontColorForMethod(actionData?.custom_api_method) : "black"}`}}>
                                    {apiMethod}
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item className={globalStyles.clickable} onClick={() => setFlagOpenCustomAPIInfoPopup(true)}>
                            <OpenInFullIcon className={styles.openInNewIconForCustomAPI} />
                        </Grid>
                    </Grid>
                </Grid>
                <Divider />
                <Grid item className={globalStyles.fullwidth}>
                    <Grid container gap={"4px"} flexWrap={"nowrap"}>
                        <Grid item xs={4} className={styles.customAPICallInfoTitle}>
                            {`${actionData?.custom_api_url ? 'URL' : 'Function Name'}`}    
                        </Grid> 
                        <Grid item xs={7.5}>
                            {urlOrFunctionName}
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item className={globalStyles.fullwidth}>
                    <Grid container gap={"4px"} alignItems={"center"}>
                        <Grid item xs={4} className={styles.customAPICallInfoTitle}>
                            Status Code
                        </Grid>
                        <Grid item xs={7.5} className={`${globalStyles.displayFlexStyle} ${globalStyles.alignItemCenter}`} flexWrap={"nowrap"}>
                            <span className={styles.customAPIStatusCode}>
                                {statusCode}
                            </span>
                            {statusCode?.startsWith("2") && <span className={globalStyles.displayFlexStyle}><IconsColor iconName="roundedRightIcon" width={16} height={16} /></span>} 
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item className={globalStyles.fullwidth}>
                    <Grid container gap={"4px"} alignItems={"center"}>
                        <Grid item xs={4} className={styles.customAPICallInfoTitle}>
                            Executed in
                        </Grid>
                        <Grid item xs={7.5}>
                            {executionTime}
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            {flagOpenCustomAPIInfoPopup && 
                <GlobalPopUp
                    open={flagOpenCustomAPIInfoPopup}
                    handleClose={() => setFlagOpenCustomAPIInfoPopup(false)} 
                    onClose={() => setFlagOpenCustomAPIInfoPopup(false)}
                    flagShowCloseIcon={true}
                    titlePadding='0px'
                    paperMinWidth={flagSmallScreen ? "350px" : "90%"}
                    paperMaxwidth={flagSmallScreen ? "710px" : "90%"}
                >
                    <CustomAPIActionInformationPopup 
                        actionData={actionData}
                        apiMethod={apiMethod}
                        urlOrFunctionName={urlOrFunctionName}
                        statusCode={statusCode}
                        executionTime={executionTime}
                    />
                </GlobalPopUp>
            }
        </>
    )
}

export default CustomAPIAction
